import { render, staticRenderFns } from "./app.vue?vue&type=template&id=006187c0&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "./app.vue?vue&type=style&index=0&lang=css&"
import style1 from "./app.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./app.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./app.vue?vue&type=style&index=3&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QMenu,QColor,QRating} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QMenu,QColor,QRating})
